import React, { useState, useEffect } from 'react';
import Table from './components/Table';
import { Ingredient } from './types';
import { getAllIngredientsByLocalId } from '../../../../crud/menu_api/ingredients';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { MPPageTitle } from '../../../../components/ui';

const IngredientDisplay: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [filteredIngredients, setFilteredIngredients] = useState<Ingredient[]>([]);
  const [ingredients, setIngredients] = useState<Ingredient[]>([]);
  const [originalIngredients, setOriginalIngredients] = useState<Ingredient[]>([]);

  useEffect(() => {
    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    
    setLoading(true);
    getAllIngredientsByLocalId(localId)
      .then((response) => {
        setIngredients(response.data);
        setFilteredIngredients(response.data);
        setOriginalIngredients(response.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingSpinner text="Cargando ingredientes..." transparent={true}/>
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Ingredientes</MPPageTitle>
      
      <Table 
        ingredients={filteredIngredients} 
        setIngredients={setIngredients} 
        originalIngredients={originalIngredients} 
        setOriginalIngredients={setOriginalIngredients}
      />
    </div>
  );
};

export default IngredientDisplay;